module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/chevronDownCM.a35c9d50.svg";